import { render, staticRenderFns } from "./ProductHierarchy.vue?vue&type=template&id=4045fbce&scoped=true"
import script from "./ProductHierarchy.vue?vue&type=script&lang=js"
export * from "./ProductHierarchy.vue?vue&type=script&lang=js"
import style0 from "./ProductHierarchy.vue?vue&type=style&index=0&id=4045fbce&prod&scoped=true&lang=css"
import style1 from "./ProductHierarchy.vue?vue&type=style&index=1&id=4045fbce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045fbce",
  null
  
)

export default component.exports